import "./stage.css"

function readQuery() {
  const params = new URLSearchParams(location.search)
  return {
    projectId: params.get("projectId") || "",
    ready: params.has("rb_ai_news"),
  }
}

function boot() {
  document.documentElement.dataset.rbStage = "ai-news"
  document.documentElement.dataset.directorScene = "ai-news"

  const meta = document.getElementById("rb-stage-meta")
  const { projectId, ready } = readQuery()

  if (meta) {
    if (ready && projectId) {
      meta.textContent = `工程 ${projectId.slice(-10)} · 等待扩展注入模板`
    } else if (ready) {
      meta.textContent = "已进入舞台模式 · 等待扩展注入模板"
    } else {
      meta.textContent = "提示：扩展打开时应带 ?rb_ai_news=1"
    }
  }

  console.info("[ai-news-stage] ready", { projectId, ready, href: location.href })
}

boot()
